import React, { useEffect, useState } from 'react';
import { Spinner, Form } from 'react-bootstrap';
import { API } from '../../data/API/API';
import './EmailTemplateRadioButtons.scss'; // Import custom styles

export interface EmailTemplate {
    id: number;
    templateName: string;
    header: string;
    body: string;
    active: boolean;
}

interface EmailTemplateRadioButtonsProps {
    onTemplateSelect: (template: EmailTemplate) => void; // Prop for selecting a template
    selectedTemplate: EmailTemplate | null; // Prop for the currently selected template
}

const EmailTemplateRadioButtons: React.FC<EmailTemplateRadioButtonsProps> = ({ onTemplateSelect, selectedTemplate }) => {
    const [isLoading, setLoading] = useState(true);
    const [templates, setTemplates] = useState<EmailTemplate[]>([]);
    const [selectedTemplateId, setSelectedTemplateId] = useState<number | null>(selectedTemplate ? selectedTemplate.id : null);
    const [errorMsg, setErrorMsg] = useState<string | null>(null);

    useEffect(() => {
        const fetchTemplates = async () => {
            try {
                const fetchedTemplates = await API.EmailTemplates.GetAllEmailTemplates();
                const activeTemplates = fetchedTemplates.filter((template: EmailTemplate) => template.active);
                setTemplates(activeTemplates);
                setLoading(false);
            } catch (error) {
                setErrorMsg("Kunde inte hämta e-postmallar."); // Translated error message
                setLoading(false);
            }
        };
        fetchTemplates();
    }, []);

    // Update selected template when passed in from props
    useEffect(() => {
        if (selectedTemplate) {
            setSelectedTemplateId(selectedTemplate.id);
        }
    }, [selectedTemplate]);

    const handleTemplateChange = (templateId: number) => {
        setSelectedTemplateId(templateId);
        const selectedTemplate = templates.find(template => template.id === templateId);
        if (selectedTemplate) {
            onTemplateSelect(selectedTemplate); // Call the parent prop function with the selected template
        }
    };

    return (
        <div>
            {isLoading ? (
                <Spinner animation="border" />
            ) : (
                <>
                    {errorMsg && <div className="error-message">{errorMsg}</div>}
                    <Form>
                        {templates.map(template => (
                            <div
                                key={template.id}
                                className="email-template-radio-container"
                                onClick={() => handleTemplateChange(template.id)} // Make the entire container clickable
                            >
                                <Form.Check
                                    type="radio"
                                    id={`template-${template.id}`}
                                    name="emailTemplate"
                                    value={template.id}
                                    checked={selectedTemplateId === template.id}
                                    onChange={() => handleTemplateChange(template.id)}
                                    className="email-template-radio-input"
                                />
                                <Form.Label className="email-template-radio-label" htmlFor={`template-${template.id}`}>
                                    {template.templateName}
                                </Form.Label>
                            </div>
                        ))}
                    </Form>
                </>
            )}
        </div>
    );
};

export default EmailTemplateRadioButtons;

